export default __webpack_public_path__ + "static/media/escholl.e7067efe.PNG";